export default __webpack_public_path__ + "c0bec65d01f776c00c91a077acb1c2e8.woff2";